/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-19 11:39:10
 *
 *******************************************************/
// @flow
import React, { useState } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Banner, Heading, TextStyle, Button, Icon, Grid } from '@shopify/polaris';
import { CircleTickMajor } from '@shopify/polaris-icons';
import EnableBoostCore from 'src/assets/images/recommendation/enable-boost-core.png';
import AddAppBlock from 'src/assets/images/recommendation/add-app-block.png';

import { URL } from 'src/constants/links';

const StoreV2Tab = props => {
  const [enableBoostCoreVideo, setEnableBoostCoreVideo] = useState(false);
  const [addAppBlockVideo, setAddAppBlockVideo] = useState(false);

  const { i18n, handleOpenBoostCore, enabledBoostCore, handleOpenThemeEditor } = props;

  return (
    <div className="online-store-v2">
      <Heading>
        {i18n.translate('AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.subtext')}
      </Heading>
      <div className="step-guide step01">
        <Grid>
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }}>
            <div className="content">
              <TextStyle variation="strong">
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step01_Label'
                )}
              </TextStyle>
              <div>
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step01_Content',
                  {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step01_Content_t1'
                        )}
                      </TextStyle>
                    )
                  }
                )}
              </div>
              {enabledBoostCore ? (
                <p>
                  <Icon source={CircleTickMajor} color="success" />
                  {i18n.translate(
                    'AdminHTML.Recommendation.WidgetStepsGuideInstall.enableBoostCore'
                  )}
                </p>
              ) : (
                <Button onClick={handleOpenBoostCore} primary>
                  {i18n.translate(
                    'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step01_Action'
                  )}
                </Button>
              )}
            </div>
          </Grid.Cell>
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
            <div className="video">
              <div className="BC-Iframe-Container">
                {enableBoostCoreVideo ? (
                  <iframe
                    width="360"
                    height="110"
                    src={`${URL['Link_V2_Recommendation_ManageWidget_Video']}&start=276&autoplay=1`}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
                ) : (
                  <img
                    src={EnableBoostCore}
                    alt="enable-boost-core"
                    style={{ width: '100%' }}
                    onClick={() => setEnableBoostCoreVideo(true)}
                  />
                )}
              </div>
            </div>
          </Grid.Cell>
        </Grid>
      </div>
      <div className="step-guide step02">
        <Grid>
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }}>
            <div className="content">
              <TextStyle variation="strong">
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step02_Label'
                )}
              </TextStyle>
              <div>
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step02_Content01',
                  {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step02_Content_t1'
                        )}
                      </TextStyle>
                    ),
                    t2: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step02_Content_t2'
                        )}
                      </TextStyle>
                    ),
                    t3: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step02_Content_t3'
                        )}
                      </TextStyle>
                    )
                  }
                )}
              </div>
              <div>
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step02_Content02',
                  {
                    t4: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step02_Content_t4'
                        )}
                      </TextStyle>
                    ),
                    t5: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step02_Content_t5'
                        )}
                      </TextStyle>
                    ),
                    t6: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step02_Content_t6'
                        )}
                      </TextStyle>
                    )
                  }
                )}
              </div>
              <Button onClick={handleOpenThemeEditor} primary>
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step02_Action'
                )}
              </Button>
            </div>
          </Grid.Cell>{' '}
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
            <div className="video">
              <div className="BC-Iframe-Container">
                {addAppBlockVideo ? (
                  <iframe
                    width="360"
                    height="110"
                    src={`${URL['Link_V2_Recommendation_ManageWidget_Video']}&start=296&autoplay=1`}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
                ) : (
                  <img
                    src={AddAppBlock}
                    alt="add-app-block"
                    style={{ width: '100%' }}
                    onClick={() => setAddAppBlockVideo(true)}
                  />
                )}
              </div>
            </div>
          </Grid.Cell>
        </Grid>
      </div>
      <Banner status="info">
        <p>
          {i18n.translate('AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.blockContent', {
            t1: (
              <strong>
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.blockContent_t1'
                )}
              </strong>
            )
          })}
        </p>
      </Banner>
    </div>
  );
};
export default withI18n()(StoreV2Tab);
